import React from "react";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";

const useStyles = makeStyles({
  paper: (props) => ({
    padding: "2rem",
    marginBottom: "5rem",
    borderBottomStyle: "solid",
    borderBottomColor: props.item.color,
    borderBottomWidth: "4px",
    borderLeftStyle: "solid",
    borderLeftColor: props.item.color,
    borderLeftWidth: "10px",
    "&.MuiPaper-root": {
      width: "100%",
      backgroundColor: "#2a2a2a",
      color: "#ababab",
    },
    "& > .MuiTypography-root": {
      fontFamily: "Rajdhani",
      fontWeight: 500,
    },
  }),
  designation: {
    "&.MuiTypography-root": {
      fontWeight: 700,
      fontSize: "3rem",
      lineHeight: "2.3rem",
      color: "#FFFFFF",
    },
  },
});

function SkillProfessionItem(props) {
  const { item } = props;
  const classes = useStyles(props);
  return (
    <>
      <Paper className={classes.paper} elevation={0}>
        <Typography className={classes.designation} variant="h3">
          {item.designation}
        </Typography>
        <Typography variant="h4" mt={2}>
          {item.company}
        </Typography>
        <Typography variant="h5" mb={2}>
          {item.date}
        </Typography>
        <Typography variant="body1" fontSize="1.8rem">
          {item.jobDetails}
        </Typography>
      </Paper>
    </>
  );
}

export default SkillProfessionItem;
